import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42b15050"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-grow flex-col grid grid-cols-1 sm:grid-cols-9" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-1" }, null, -1))
const _hoisted_3 = { class: "sm:col-span-4 main-content sm:pt-32" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "sm:col-span-4 flex flex-col justify-center items-center bg-project" }
const _hoisted_7 = { class: "relative" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  id: "image-map",
  name: "image-map"
}
const _hoisted_10 = ["coords", "onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "bg-white border-project border-4 rounded-sm flex flex-col relative max-w-4xl" }
const _hoisted_13 = { class: "flex flex-row items-end" }
const _hoisted_14 = { class: "p-4 pb-12" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "justify-end items-end flex-col flex h-full relative" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "img/gograss/grasspopup.png",
    class: "w-full"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackNextButtons = _resolveComponent("BackNextButtons")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["screen-content relative p-0", _ctx.config.classes?.wrapperClasses])
  }, [
    _createVNode(_component_ScreenWrapper, {
      "class-name": "pt-0 bg-white",
      next: _ctx.next,
      screen: _ctx.screen,
      "hide-arrow": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", {
              class: "mt-8",
              innerHTML: _ctx.$rt(_ctx.config.textPart1, {name: _ctx.state.nickname.value})
            }, null, 8, _hoisted_4),
            _createElementVNode("p", {
              class: "mt-8",
              innerHTML: _ctx.$rt(_ctx.config.textPart2, {name: _ctx.state.nickname.value})
            }, null, 8, _hoisted_5),
            _createVNode(_component_BackNextButtons, {
              class: "hidden sm:block",
              "go-to": _ctx.next,
              "next-screen": _ctx.config.screenNext,
              "button-class": "action-button mt-8"
            }, null, 8, ["go-to", "next-screen"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("img", {
                src: _ctx.config.image1,
                class: "w-full relative",
                alt: "Logo",
                usemap: "#image-map",
                ref: "imageMapImage",
                onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateImageMap && _ctx.updateImageMap(...args)))
              }, null, 40, _hoisted_8),
              _createElementVNode("map", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageMaps, (area, index) => {
                  return (_openBlock(), _createElementBlock("area", {
                    key: area,
                    shape: "rect",
                    alt: "",
                    title: "",
                    coords: area,
                    href: "#",
                    target: "",
                    onClick: _withModifiers(($event: any) => (_ctx.imageMapSelect(index)), ["prevent"])
                  }, null, 8, _hoisted_10))
                }), 128))
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageMapOverlays, (area, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: area,
                  class: _normalizeClass(["absolute inset-0 border-2 opacity-0 cursor-pointer rounded-sm bg-white hover:opacity-25", {'opacity-50 border-project-dark': _ctx.selectedAreas[index]}]),
                  onClick: _withModifiers(($event: any) => (_ctx.imageMapSelect(index)), ["prevent"]),
                  style: _normalizeStyle({top: area[1] + 'px', left: area[0] + 'px', width: area[2] - area[0] + 'px', height: area[3] - area[1] + 'px'
           })
                }, null, 14, _hoisted_11))
              }), 128))
            ])
          ]),
          _createVNode(_component_BackNextButtons, {
            class: "block sm:hidden",
            "go-to": _ctx.next,
            "next-screen": _ctx.config.screenNext,
            "button-class": "action-button mt-8"
          }, null, 8, ["go-to", "next-screen"])
        ]),
        _createVNode(_component_Modal, {
          modelValue: _ctx.showModal,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showModal) = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.showModal = false; _ctx.next()}),
                class: "absolute top-2 right-4 text-project font-bold text-3xl text-right"
              }, " × "),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.config.popupTexts, (text) => {
                    return (_openBlock(), _createElementBlock("p", {
                      key: text,
                      class: "mt-8",
                      innerHTML: _ctx.$rt(text, {name: _ctx.state.nickname.value})
                    }, null, 8, _hoisted_15))
                  }), 128))
                ]),
                _hoisted_16
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["next", "screen"])
  ], 2))
}